import $ from "jquery";

export function front() {


  (function ($, Drupal, once, drupalSettings) {

    Drupal.behaviors.noahsFront = {
      attach: function (context) {

        $(once('noahsFrontInit', 'body', context)).each(function () {

          setTimeout(() => {
            if($('#noahs_page_builder').length){
              historyChanges();
            }
          }, 50);

          if (window.location.hash) {
              var hash = window.location.hash;
          
              if ($(hash).length) {
                  $('html, body').animate({
                      scrollTop: $(hash).offset().top
                  }, 900, 'swing');
              }
          }

          $('.accordion').on('shown.bs.collapse', function () {
              $(this).find('.accordion-header.active').removeClass('active'); // Elimina la clase 'active' de cualquier otro encabezado activo
              $(this).find('.accordion-button[aria-expanded="true"]').closest('.accordion-header').addClass('active'); // Agrega la clase 'active' al encabezado activo
            });

            $('.accordion').on('hidden.bs.collapse', function () {
              $(this).find('.accordion-header').removeClass('active'); // Elimina la clase 'active' cuando el cuerpo se colapsa
            });
            $('.noahs-theme--open-tabs').on('click', function(e){
              e.preventDefault();
          
              $('.noahs-theme--tabs-wrapper').toggleClass('hidden');
            })

            $('a.noahs-use-ajax:not(.f-admin)').on('click', function(e){
              e.preventDefault();
            
              // Obtener la URL correctamente.
              var url = $(this).attr('href');
            
              // Obtener las opciones de diálogo desde 'data-dialog-options'
              var settings = $(this).data('dialog-options');
              var decodedString = $('<div/>').html(settings).text(); // Decodificación de HTML
              var jsonObject = JSON.parse(decodedString);
            
              // Configurar las opciones de AJAX con un solo objeto
              var ajaxSettings = {
                url: url,
                dialogType: 'modal', 
                dialog: jsonObject,
                // El 'element' es el mismo enlace donde ocurre el clic
                element: $(this)
              };
            
              // Crear el objeto Drupal.ajax con un único parámetro (objeto de configuración)
              var myAjaxObject = new Drupal.ajax(ajaxSettings);
            
              // Ejecutar la llamada AJAX
              myAjaxObject.execute();
            });
            
            // Inicializar otros módulos front-end
          window.NohasInitFront();
        });
      }
    };
  })(jQuery, Drupal, once, drupalSettings);


  function skillBars(){
    const elements = document.querySelectorAll('.on-viewport'); 
    if (elements.length === 0) return; 

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { 
          entry.target.classList.add('viewport-active');
          observer.unobserve(entry.target); 
        }
      });
    });

    elements.forEach(element => observer.observe(element)); 
    document.querySelectorAll(".progress-line span").forEach((el) => {
      
      const updateWidth = () => {
        const width = el.getAttribute("data-width");
        if (width) {
          el.style.width = width + "%";
        }
      };

      updateWidth();

      const observer = new MutationObserver(() => {
        updateWidth(); 
      });

      observer.observe(el, { attributes: true, attributeFilter: ["data-width"] });
    });
  };

    window.NohasInitFront = function(html) {

        if(!html){
            html = $('body');
        }
        $(html).find('.noahs_page_builder-slideshow').each(function (index, element) {
            $(this).attr('id', 'slide_' + index);
            if ($('#slide_' + index + ' .swiper-slide').length >= 1) {
                var slide = new Swiper('#slide_' + index, {
                    autoplay: { 
                        delay: 5000,
                    },
                    pagination: {
                      el: ".swiper-pagination",
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev', 
                    }
                });
            }
        });

        $(html).find('.noahs_page_builder-slideshow-services').each(function (index, element) {
            $(this).attr('id', 'slide_services_carousel_' + index);
            if ($('#slide_services_carousel_' + index + ' .swiper-slide').length >= 1) {

                var show_items = $(this).data('show-items-desktop') ?? 4;
                var show_items_tablet = $(this).data('show-items-tablet') ?? 2;
                var show_items_mobile = $(this).data('show-items-mobile') ?? 1;
                var space = $(this).data('space') ?? 20;

                var slide_services = new Swiper('#slide_services_carousel_' + index, {
                    slidesPerView: show_items_mobile,
                    spaceBetween: space,
                    autoplay: { 
                        delay: 5000,
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev', 
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: show_items_tablet,
                        },
                        1024: {
                          slidesPerView: show_items,
                        },
                      },
                });
            }
        });

        $(html).find('.noahs_page_builder-carousel').each(function (index, element) {
          var show_items = $(this).data('show-items-desktop') ? $(this).data('show-items-desktop') : 4;
          var show_items_tablet = $(this).data('show-items-tablet') ?? 2;
          var show_items_mobile = $(this).data('show-items-mobile') ? $(this).data('show-items-mobile') : 1;
          var space = $(this).data('space') ?? 20;

          $(this).attr('id', 'noahs_carusel_' + index);
          if ($('#noahs_carusel_' + index + ' .swiper-slide').length >= 1) {

              var slide_image_carusel = new Swiper('#noahs_carusel_' + index, {
                slidesPerView: show_items_mobile,
                spaceBetween: space,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                }, 
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev', 
                },
                breakpoints: {
                    768: {
                      slidesPerView: show_items_tablet,
                    },
                    1024: {
                      slidesPerView: show_items,
                    },
                  },
              });
            }
        });

        $(html).find('.noahs_elements_carousel').each(function (index, element) {
          var show_items = $(this).data('show-items-desktop') ? $(this).data('show-items-desktop') : 4;
          var show_items_tablet = $(this).data('show-items-tablet') ?? 2;
          var show_items_mobile = $(this).data('show-items-mobile') ?? 1;
          var space = $(this).data('space') ?? 20;

          $(this).attr('id', 'slide_carousel_' + index);

          if($('#slide_carousel_' + index + ' .swiper-slide').length >= show_items){
            if ($('#slide_carousel_' + index + ' .swiper-slide').length >= 1) {

                var slide_carusel = new Swiper('#slide_carousel_' + index, {
                    slidesPerView: show_items_mobile,
                    spaceBetween: space,
                    autoplay: {
                        delay: 5000,
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    }, 
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev', 
                    },
                    breakpoints: {
                        768: {
                          slidesPerView: show_items_tablet,
                        },
                        1024: {
                          slidesPerView: show_items,
                        },
                      },
                });
            }
          }
        });

        $(html).find('.testimonial-slider').each(function (index, element) {
            $(this).attr('id', 'testimonial_carousel_' + index);
            if ($('#testimonial_carousel_' + index + ' .swiper-slide').length >= 1) {
                var show_items = $(this).data('count-slide') ?? 4;
                var space = $(this).data('space') ?? 20;

                var slide_testimonials = new Swiper('#testimonial_carousel_' + index, {
                    slidesPerView: 1,
                    spaceBetween: space,
                    autoplay: {
                        delay: 5000,
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev', 
                    },
                    breakpoints: {
                        769: {
                          slidesPerView: show_items,
                        }
     
                      },
                });
            }
        });
        
        //accordion
        $(html).find('.accordion').each(function (index, element) {

          const maxItemsToShowFirst = $(this).data('max-items');
          const totalItems = $(this).data('items-total');

      
          // Mostrar más elementos al hacer clic en "Ver más"
          $('#showMoreButton').on('click', function () {
              // Mostrar todos los elementos ocultos
              $('.hidden').removeClass('hidden');
              // Alternar la visibilidad de los botones
              $(this).hide();
              $('#showLessButton').show();
          });
      
          // Ocultar elementos al hacer clic en "Ver menos"
          $('#showLessButton').on('click', function () {
              // Ocultar los elementos adicionales
              $('.accordion-item').each(function (index) {
                  if (index >= maxItemsToShowFirst) {
                      $(this).addClass('hidden');
                  }
              });
              // Alternar la visibilidad de los botones
              $(this).hide();
              $('#showMoreButton').show();
          });
        });



        var today = new Date();
        var futureDate = new Date(today);
            futureDate.setDate(today.getDate() + 2);
        
        var timestamp = Math.floor(futureDate.getTime() / 1000);
        
        $(once('noahsCountDown', '.noahs_page_builder-countdown')).each(function (index, element) {
            var date = $(this).data('countdown') ? $(this).data('countdown') : timestamp;
            $(this).attr('id', 'flipdown_' + index);
            new FlipDown(date, "flipdown_" + index, {
                headings: [$(this).data('days'), $(this).data('hours'), $(this).data('minutes'), $(this).data('seconds')],
            }).start();
        });
        
        AOS.init();
        skillBars();
       



    }



    // Dropdown language
    $('.noahs-language-switcher.dropdown > .caption').on('click', function() {
      $(this).parent().toggleClass('open');
    });
    
    $('.noahs-language-switcher.dropdown > .list > .item').on('click', function() {
      $('.dropdown > .list > .item').removeClass('selected');
      $(this).addClass('selected').parent().parent().removeClass('open').children('.caption').text( $(this).text() );
    });
    $(document).on("click", ".cart-block--contents__close", function() {
      $('.cart-block--contents').removeClass('cart-block--contents__expanded');
      $('.cart-block--contents').hide();
    });
     
    $(document).on('keyup', function(evt) {
        if ( (evt.keyCode || evt.which) === 27 ) {
            $('.noahs-language-switcher.dropdown').removeClass('open');
        }
    });
    
    $(document).on('click', function(evt) {
        if ( $(evt.target).closest(".noahs-language-switcher.dropdown > .caption").length === 0 ) {
            $('.noahs-language-switcher.dropdown').removeClass('open');
        }
    });




}